// @flow
import { getAuthToken, getBidderId } from './user';
import { getRequestedAuctionRegistrationAnalytics, trackConversionForAlgolia } from './analytics';
import api from '../api/catalog';
import { createSelector } from 'reselect';
import { fetchBidLimitBalanceIfNeeded } from './bidLimit';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';
import { OPEN_REGISTER_FOR_CATALOG_MODAL } from './modal';

/* Action Types */
export const REGISTER_FOR_CATALOG_FAIL = 'la/ui/registerForCatalog/FAIL';
export const REGISTER_FOR_CATALOG_REQUEST = 'la/ui/registerForCatalog/REQUEST';
export const REGISTER_FOR_CATALOG_SUCCESS = 'la/ui/registerForCatalog/SUCCESS';

/* reducer */
const DEFAULT_STATE = {
    catalogId: null,
    error: false,
    fromBiddingConsole: false,
    itemId: null,
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
    catalogId: ?number,
    itemId: ?number,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case OPEN_REGISTER_FOR_CATALOG_MODAL:
            return {
                ...state,
                catalogId: action.payload.catalogId,
                fromBiddingConsole: action.payload.fromBiddingConsole ? action.payload.fromBiddingConsole : false,
                itemId: action.payload.itemId ? action.payload.itemId : null,
            };
        case REGISTER_FOR_CATALOG_FAIL:
            return {
                ...state,
                error: true,
                submitted: false,
                success: false,
            };
        case REGISTER_FOR_CATALOG_REQUEST:
            return {
                ...state,
                submitted: true,
                success: false,
            };
        case REGISTER_FOR_CATALOG_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const registerForCatalogSelector = (state: GlobalState) => state.registerForCatalog;

export const getUserRegisterForCatalog = createSelector(
    registerForCatalogSelector,
    catalogRegistrations => catalogRegistrations
);

/* ACTION CREATORS */
type SubmitRegisterForCatalogParams = {
    catalogId: number,
    itemId: number,
};

export const submitRegisterForCatalog = ({ catalogId, itemId }: SubmitRegisterForCatalogParams) => async (
    dispatch: Function,
    getState: Function
) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const bidderId = getBidderId(state);
        const deployment = getDeployment(state);

        dispatch({ type: REGISTER_FOR_CATALOG_REQUEST });

        const response = await api.postRegisterForCatalog({ authToken, bidderId, catalogId, deployment, itemId });
        const analytics = getRequestedAuctionRegistrationAnalytics(state, catalogId, itemId);
        dispatch(trackConversionForAlgolia(itemId));
        await dispatch({
            meta: { analytics: analytics.analytics },
            payload: response.payload,
            type: REGISTER_FOR_CATALOG_SUCCESS,
        });
        dispatch(fetchBidLimitBalanceIfNeeded(catalogId));
    } catch (error) {
        dispatch({
            error: true,
            meta: { catalogId },
            payload: error,
            type: REGISTER_FOR_CATALOG_FAIL,
        });
    }
};
